import restClient from "api/restClient";
import NotificationService from "components/Notification/Notification.service";
import { actions as statsActions } from "containers/Stats/Stats.reducer";
import { call, put, takeEvery } from "redux-saga/effects";

/**
 * Fetch Stat
 * @param  {Object} promise
 * @param {string} id Stat ID
 * @return {Object} response from API
 */
export function* fetchStats({ promise, endpoint, iri, params }) {
    try {
        yield put({
            type: statsActions.STORE_STAT_DATA,
            iri,
            response: {},
        });
        const fetchSingleStatAPI = yield restClient.post(endpoint, params);
        yield put({
            type: statsActions.STORE_STAT_DATA,
            iri,
            response: fetchSingleStatAPI?.data,
        });
        yield put({
            type: statsActions.FETCH_STAT_SUCCESSFUL,
            iri,
        });
        yield call(promise.resolve);
    } catch (error) {
        yield put({
            type: statsActions.FETCH_STAT_FAILED,
            iri,
        });
        yield call(promise.reject, error?.response?.data || error);
        NotificationService.error(error?.response?.data || error); // TODO (medium) should use <RestErrorNotification> here, but leads to unexpected webpack error
    }
}

/**
 * Register action to watcher
 */
export default [takeEvery(statsActions.START_FETCHING_STAT, fetchStats)];
